import { Box, Spinner } from "@chakra-ui/react";
import SettingsHeader from "../elements/SettingsHeader";
import SettingsDescription from "../elements/SettingsDescription";
import { useState, useEffect } from "react";

import { apiGetRequest } from "utils/api";
import {
	IntegrationCard,
	IntegrationCardProps,
} from "./@components/IntegrationCard";

import HubspotLogo from "./@assets/hubspot.png";
import XeroLogo from "./@assets/xero.png";

type ConnectedClient = {
	provider_name: string;
};

const Integrations: IntegrationCardProps[] = [
	{
		controller: "hub-spot",
		name: "HubSpot",
		description:
			"Connect your CRM to sync contacts and loan data with Hubspot.",
		logo: HubspotLogo,
		connected: false,
	},
	{
		controller: "xero",
		name: "Xero",
		description:
			"Integrate with Xero for seamless accounting and financial management.",
		logo: XeroLogo,
		connected: false,
	},
];

export default function IntegrationSettings() {
	const [integrations, setIntegrations] = useState<IntegrationCardProps[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchOauthConnectedClients = async () => {
			try {
				const connectedClients =
					await apiGetRequest<ConnectedClient[]>("/oauth-clients");

				const integrationList = Integrations.map((integration) => {
					const client = connectedClients.find(
						(client) =>
							client.provider_name.toLowerCase() ===
							integration.name.toLowerCase()
					);

					return {
						...integration,
						connected: client ? true : false,
					};
				});

				setIntegrations(integrationList);
			} catch (error) {
				console.error("Error fetching OAuth clients:", error);
			}
		};

		setIsLoading(true);
		fetchOauthConnectedClients().finally(() => {
			setIsLoading(false);
		});
	}, []);

	return (
		<Box maxW="1200px" mx="auto" px={{ base: "16px", md: "24px" }}>
			<SettingsHeader title="Integrations" />
			<SettingsDescription text="Connect your tools to optimize your business performance." />
			{isLoading ? (
				<Spinner />
			) : (
				<Box
					display="grid"
					gridTemplateColumns={{
						base: "1fr",
						md: "repeat(2, 1fr)",
						lg: "repeat(2, 1fr)",
					}}
					gap="24px"
					mt="24px"
				>
					{integrations.map((integration) => (
						<IntegrationCard key={integration.name} {...integration} />
					))}
				</Box>
			)}
		</Box>
	);
}
